export const topicsData = [
  { id: 1, tag: "悬疑烧脑剧", heat: "128万热度", icon: "ri-fire-line" },
  { id: 2, tag: "古装大女主", heat: "96万热度", icon: "ri-fire-line" },
  { id: 3, tag: "甜宠偶像剧", heat: "85万热度", icon: "ri-heart-line" },
  { id: 4, tag: "高分纪录片", heat: "72万热度", icon: "ri-star-line" },
  { id: 5, tag: "韩剧精选", heat: "68万热度", icon: "ri-tv-line" },
  { id: 6, tag: "国产高分剧", heat: "59万热度", icon: "ri-flag-line" },
  { id: 7, tag: "好莱坞大片", heat: "53万热度", icon: "ri-film-line" },
  { id: 8, tag: "日漫番剧", heat: "47万热度", icon: "ri-ancient-gate-line" },
  { id: 9, tag: "真人秀综艺", heat: "41万热度", icon: "ri-live-line" },
  { id: 10, tag: "动作枪战", heat: "36万热度", icon: "ri-rocket-line" },
  { id: 11, tag: "温情家庭剧", heat: "32万热度", icon: "ri-home-heart-line" },
];

export const aboutData = {
  title: "海量高清影视，随时随地免费看",
  description: "菲菲影院致力于为广大影迷打造高品质的在线观影体验。平台汇聚超过10万部电影、电视剧、综艺、动漫资源，涵盖全球热门内容。我们持续优化播放技术，确保高清画质与流畅播放的完美结合，让你告别卡顿和缓冲。每日更新最新剧集和片源，热门内容第一时间上线，追剧再也不用等。菲菲影院支持多端同步观看，电脑、手机、平板无缝切换，让你随时随地享受视听盛宴。",
  highlights: ["覆盖全球热门内容", "高清画质流畅不卡顿", "每日更新追剧零延迟", "多端同步随时随地看"],
};

export const cardsData = [
  {
    id: 1,
    title: "悬疑剧场上新",
    desc: "烧脑神作连番登场，反转剧情让你猜不到结局，一口气刷完才过瘾。",
    tag: "热播",
    image: "https://readdy.ai/api/search-image?query=Suspense%20thriller%20movie%20scene%20with%20dramatic%20lighting%20dark%20tones%20mysterious%20atmosphere%20cinematic%20film%20noir%20style%20warm%20golden%20highlights%20on%20dark%20background%20high%20quality%20cinematic%20photography%20soft%20shadows&width=800&height=500&seq=card-01&orientation=landscape",
  },
  {
    id: 2,
    title: "古装传奇巨制",
    desc: "服化道精良，剧情扣人心弦，实力派演员倾情演绎历史风云。",
    tag: "推荐",
    image: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20costume%20drama%20elegant%20palace%20scene%20warm%20golden%20lighting%20silk%20fabrics%20flowing%20in%20wind%20artistic%20cinematic%20composition%20soft%20focus%20rich%20textures%20warm%20amber%20tones&width=800&height=500&seq=card-02&orientation=landscape",
  },
  {
    id: 3,
    title: "高分韩剧合集",
    desc: "精选近年口碑爆款韩剧，甜虐交织、题材多元，满足你的追剧欲。",
    tag: "热门",
    image: "https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20scene%20warm%20cozy%20atmosphere%20couple%20under%20cherry%20blossoms%20soft%20pastel%20colors%20cinematic%20lighting%20dreamy%20mood%20gentle%20sunlight%20emotional%20storytelling%20vibe&width=800&height=500&seq=card-03&orientation=landscape",
  },
  {
    id: 4,
    title: "院线大片速递",
    desc: "下映即上线，高清画质不输影院，周末宅家也能看新片。",
    tag: "新片",
    image: "https://readdy.ai/api/search-image?query=Epic%20action%20movie%20scene%20cinematic%20wide%20shot%20dramatic%20sky%20warm%20sunset%20colors%20heroic%20silhouette%20high%20contrast%20professional%20film%20grade%20color%20grading%20grand%20scale%20atmosphere&width=800&height=500&seq=card-04&orientation=landscape",
  },
  {
    id: 5,
    title: "治愈系动漫",
    desc: "画风精美故事温暖，每一帧都是壁纸，治愈你疲惫的一天。",
    tag: "精选",
    image: "https://readdy.ai/api/search-image?query=Beautiful%20anime%20style%20landscape%20warm%20sunset%20glow%20soft%20clouds%20pastel%20color%20palette%20dreamy%20atmosphere%20artistic%20illustration%20calm%20peaceful%20scenery%20golden%20hour%20lighting%20emotional%20tone&width=800&height=500&seq=card-05&orientation=landscape",
  },
];

export const appData = {
  title: "手机追剧更自由",
  subtitle: "扫码下载菲菲影院APP，随时随地畅享高清影视",
  features: ["离线缓存，无网络也能看", "投屏电视，大屏更过瘾", "弹幕互动，边看边聊", "倍速播放，追剧更高效"],
};

export const indexData = [
  { id: 1, title: "2024年度高分剧集榜", count: "30部", icon: "ri-trophy-line", color: "bg-primary-500" },
  { id: 2, title: "悬疑推理：烧脑必看合集", count: "45部", icon: "ri-search-eye-line", color: "bg-accent-500" },
  { id: 3, title: "古装美学：服化道天花板", count: "38部", icon: "ri-vip-crown-line", color: "bg-primary-500" },
  { id: 4, title: "甜宠恋爱：糖分超标预警", count: "52部", icon: "ri-heart-pulse-line", color: "bg-accent-500" },
  { id: 5, title: "韩剧必看：口碑零差评", count: "28部", icon: "ri-star-smile-line", color: "bg-secondary-500" },
  { id: 6, title: "好莱坞动作：肾上腺素飙升", count: "36部", icon: "ri-rocket-2-line", color: "bg-primary-500" },
  { id: 7, title: "国漫崛起：良心国创推荐", count: "42部", icon: "ri-brush-line", color: "bg-accent-500" },
  { id: 8, title: "纪录片：拓宽认知边界", count: "25部", icon: "ri-global-line", color: "bg-secondary-500" },
  { id: 9, title: "综艺下饭：笑着吃完每顿饭", count: "33部", icon: "ri-emotion-laugh-line", color: "bg-primary-500" },
];

export const faqData = [
  {
    id: 1,
    q: "菲菲影院的视频画质怎么样？",
    a: "菲菲影院全站采用高清片源，支持720P、1080P及4K超清画质。我们配备了智能CDN加速节点，确保你在任何网络环境下都能获得流畅的观影体验，真正做到高清不缓冲。",
  },
  {
    id: 2,
    q: "需要付费才能观看吗？",
    a: "完全不需要！菲菲影院所有内容均免费在线观看，无需充值会员，也没有隐藏收费。我们坚持做纯粹的免费影视平台，让每个热爱影视的人都能无障碍追剧看电影。",
  },
  {
    id: 3,
    q: "剧集更新速度怎么样？",
    a: "我们的内容团队每日实时跟进各大平台更新，热门剧集播出后最快1小时内上线，让你第一时间追到最新剧情。电影方面，院线下映后也会尽快上线高清版本。",
  },
  {
    id: 4,
    q: "支持哪些设备观看？",
    a: "菲菲影院全面适配电脑、平板、手机等多种设备，你可以通过浏览器直接访问，也可以下载我们的APP获得更佳体验。支持投屏功能，轻松投到电视大屏上观看。",
  },
  {
    id: 5,
    q: "观看时需要安装插件吗？",
    a: "完全不需要！菲菲影院基于HTML5播放技术，打开浏览器即可观看，无需安装任何播放器或插件。我们持续优化播放内核，兼容主流浏览器，给你最便捷的观影方式。",
  },
  {
    id: 6,
    q: "有没有弹幕和互动功能？",
    a: "当然有！菲菲影院APP端支持实时弹幕发送，你可以和万千影迷一起边看边聊。网页端也可以查看热门弹幕，让你不再孤单追剧。还有评论区可以和其他观众交流观后感。",
  },
];

export const commentsData = [
  {
    id: 1,
    name: "追剧小达人",
    avatar: "https://readdy.ai/api/search-image?query=Cute%20cartoon%20girl%20avatar%20warm%20color%20palette%20simple%20style%20round%20portrait%20illustration%20soft%20expression&width=80&height=80&seq=avatar-01&orientation=squarish",
    text: "用了菲菲影院快两年了，画质是真的好，更新也快。之前用别的平台动不动就缓冲，这边的播放体验舒服太多了，真心安利给身边所有人！",
    time: "3天前",
  },
  {
    id: 2,
    name: "深夜影评人",
    avatar: "https://readdy.ai/api/search-image?query=Cool%20cartoon%20boy%20avatar%20warm%20tone%20simple%20illustration%20round%20portrait%20stylish%20design%20minimal&width=80&height=80&seq=avatar-02&orientation=squarish",
    text: "作为一个重度电影爱好者，菲菲影院的片库真的让我惊喜。很多冷门好片都能找到，而且画质一点不含糊。希望平台越来越好，继续为大家带来好内容。",
    time: "5天前",
  },
  {
    id: 3,
    name: "宅家看世界",
    avatar: "https://readdy.ai/api/search-image?query=Friendly%20cartoon%20girl%20avatar%20warm%20orange%20tones%20simple%20round%20portrait%20illustration%20gentle%20smile&width=80&height=80&seq=avatar-03&orientation=squarish",
    text: "最喜欢菲菲影院的专题合集功能，省去了自己到处找片的时间。纪录片合集真的太棒了，周末窝在沙发上看了一整天，学到了好多知识。",
    time: "1周前",
  },
  {
    id: 4,
    name: "剧荒拯救者",
    avatar: "https://readdy.ai/api/search-image?query=Playful%20cartoon%20boy%20avatar%20warm%20colors%20simple%20round%20portrait%20illustration%20casual%20style%20friendly&width=80&height=80&seq=avatar-04&orientation=squarish",
    text: "以前经常剧荒不知道看什么，菲菲影院的热播榜单帮我找到了好多宝藏剧。分类做得特别细，想找什么类型的都能快速定位，太贴心了。",
    time: "1周前",
  },
  {
    id: 5,
    name: "光影追梦人",
    avatar: "https://readdy.ai/api/search-image?query=Artistic%20cartoon%20girl%20avatar%20warm%20amber%20tones%20simple%20round%20portrait%20illustration%20elegant%20style&width=80&height=80&seq=avatar-05&orientation=squarish",
    text: "没想到免费的体验能这么好，画面清晰流畅，没有任何广告弹窗骚扰。投屏到电视上和家人一起看，幸福感满满。菲菲影院真的是良心平台！",
    time: "2周前",
  },
];

export const rankingData = [
  { id: 1, rank: 1, title: "长安诡事录", type: "悬疑古装", hot: "TOP1", trend: "up" },
  { id: 2, rank: 2, title: "星河万里都是你", type: "都市甜宠", hot: "HOT", trend: "up" },
  { id: 3, rank: 3, title: "冰锋行动", type: "动作谍战", hot: "NEW", trend: "new" },
  { id: 4, rank: 4, title: "云端之上", type: "职场励志", hot: "HOT", trend: "up" },
  { id: 5, rank: 5, title: "山海寻踪记", type: "奇幻冒险", hot: "热播", trend: "up" },
  { id: 6, rank: 6, title: "人间烟火色", type: "温情家庭", hot: "好评", trend: "stable" },
  { id: 7, rank: 7, title: "时光里的答案", type: "年代情感", hot: "上升", trend: "up" },
];

export const carouselData = [
  {
    id: 1,
    title: "悬疑剧场：烧脑神作大赏",
    desc: "精选年度口碑悬疑佳作，反转不断让你欲罢不能，挑战你的推理极限。",
    tag: "限时推荐",
    image: "https://readdy.ai/api/search-image?query=Dark%20mysterious%20cinematic%20scene%20with%20warm%20golden%20light%20breaking%20through%20shadows%20film%20noir%20aesthetic%20dramatic%20contrast%20suspense%20atmosphere%20elegant%20composition%20high%20quality&width=1200&height=600&seq=carousel-01&orientation=landscape",
  },
  {
    id: 2,
    title: "古装大剧：东方美学盛宴",
    desc: "服化道天花板级别古装剧集，每一帧都是壁纸，感受中华传统文化之美。",
    tag: "口碑推荐",
    image: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20scene%20warm%20golden%20sunset%20lighting%20elegant%20silk%20fabrics%20traditional%20architecture%20artistic%20cinematic%20composition%20rich%20amber%20tones%20dreamy%20atmosphere&width=1200&height=600&seq=carousel-02&orientation=landscape",
  },
  {
    id: 3,
    title: "韩剧热播：高甜预警合集",
    desc: "从浪漫爱情到现实题材，韩剧的魅力在于让你笑中带泪，一集入坑。",
    tag: "观众最爱",
    image: "https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20aesthetic%20warm%20soft%20lighting%20couple%20scene%20in%20autumn%20park%20golden%20leaves%20gentle%20atmosphere%20cinematic%20photography%20emotional%20tone%20beautiful%20composition&width=1200&height=600&seq=carousel-03&orientation=landscape",
  },
  {
    id: 4,
    title: "国漫之光：良心国创推荐",
    desc: "国产动画崛起之作，精良制作不输国际水准，故事深刻画面震撼。",
    tag: "不容错过",
    image: "https://readdy.ai/api/search-image?query=Stunning%20Chinese%20animation%20style%20cinematic%20scene%20epic%20landscape%20warm%20golden%20lighting%20traditional%20elements%20with%20modern%20aesthetic%20beautiful%20color%20palette%20artistic%20composition%20grand%20atmosphere&width=1200&height=600&seq=carousel-04&orientation=landscape",
  },
];

export const mediaData = [
  {
    id: 1,
    title: "《长安诡事录》终极预告",
    duration: "02:35",
    views: "128万",
    image: "https://readdy.ai/api/search-image?query=Mysterious%20ancient%20Chinese%20detective%20drama%20scene%20warm%20lantern%20light%20dark%20alley%20atmosphere%20cinematic%20lighting%20suspense%20mood%20traditional%20costume%20thriller%20vibe&width=600&height=340&seq=media-01&orientation=landscape",
  },
  {
    id: 2,
    title: "《星河万里都是你》甜蜜花絮",
    duration: "01:48",
    views: "96万",
    image: "https://readdy.ai/api/search-image?query=Romantic%20drama%20behind%20scenes%20warm%20sunset%20lighting%20couple%20laughing%20on%20set%20soft%20focus%20gentle%20atmosphere%20golden%20hour%20cinematic%20photography%20happy%20mood&width=600&height=340&seq=media-02&orientation=landscape",
  },
  {
    id: 3,
    title: "《冰锋行动》精彩片段",
    duration: "03:12",
    views: "85万",
    image: "https://readdy.ai/api/search-image?query=Action%20spy%20thriller%20scene%20warm%20dramatic%20lighting%20intense%20chase%20sequence%20urban%20night%20setting%20cinematic%20photography%20high%20contrast%20golden%20streetlights%20suspenseful%20atmosphere&width=600&height=340&seq=media-03&orientation=landscape",
  },
  {
    id: 4,
    title: "《山海寻踪记》特辑采访",
    duration: "05:20",
    views: "62万",
    image: "https://readdy.ai/api/search-image?query=Fantasy%20adventure%20film%20set%20interview%20warm%20lighting%20creative%20workshop%20atmosphere%20artistic%20production%20design%20behind%20scenes%20cinematic%20look%20golden%20tones%20professional%20environment&width=600&height=340&seq=media-04&orientation=landscape",
  },
];

export const updatesData = [
  { id: 1, date: "2024-07-28", title: "《长安诡事录》更新至第24集", type: "更新" },
  { id: 2, date: "2024-07-27", title: "好莱坞巨制《星际边界》高清上线", type: "新片" },
  { id: 3, date: "2024-07-26", title: "《星河万里都是你》大结局已更新", type: "完结" },
  { id: 4, date: "2024-07-25", title: "平台新增4K超清专区，百部大片升级", type: "公告" },
  { id: 5, date: "2024-07-24", title: "暑期档特别策划：动画电影周开启", type: "活动" },
  { id: 6, date: "2024-07-23", title: "《冰锋行动》播放量突破5000万", type: "里程碑" },
  { id: 7, date: "2024-07-22", title: "纪录片专区新增BBC自然系列全集", type: "上新" },
];

export const contactData = {
  title: "有任何问题或建议？我们随时倾听",
  description: "无论是影片推荐、功能建议还是技术问题，欢迎通过以下方式联系我们。菲菲影院团队会在24小时内回复你的每一条反馈，你的意见是我们进步的动力。",
  email: "feedback@feifeicinema.com",
  wechat: "feifeicinema",
};

export const featuresData = [
  {
    id: 1,
    icon: "ri-4k-line",
    title: "高清画质",
    desc: "全站支持720P至4K超清画质，智能码率适配你的网络环境，每一帧都清晰细腻，给你影院级视觉享受。",
  },
  {
    id: 2,
    icon: "ri-speed-up-line",
    title: "流畅不缓冲",
    desc: "自建全球CDN加速节点，智能预加载技术，告别转圈等待。无论何时何地，点击即播，观影体验丝滑顺畅。",
  },
  {
    id: 3,
    icon: "ri-database-2-line",
    title: "海量片库",
    desc: "汇聚超过10万部电影、电视剧、综艺、动漫、纪录片资源，覆盖全球热门内容，你想看的这里全都有。",
  },
  {
    id: 4,
    icon: "ri-timer-flash-line",
    title: "极速更新",
    desc: "内容团队7×24小时轮值更新，热门剧集播后1小时内上线，院线新片下映即刻同步，追剧永不掉队。",
  },
  {
    id: 5,
    icon: "ri-smartphone-line",
    title: "多端同步",
    desc: "电脑、平板、手机无缝切换观影进度。支持投屏电视大屏观看，支持离线缓存，随时随地享受影视盛宴。",
  },
];

export const headerNavItems = [
  { label: "用户评价", href: "#comments" },
  { label: "专题合集", href: "#index" },
  { label: "平台优势", href: "#features" },
  { label: "常见问题", href: "#faq" },
  { label: "联系我们", href: "#contact" },
];